<section id="data-full-speed">
  <mprd-data-boost-skeleton *ngIf="!hasError && !dataBoosts"></mprd-data-boost-skeleton>
  <main id="maincontent" role="main" *ngIf="hasError || dataBoosts">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-has-subtit rs-txt-c2">
            {{ 'mobile.databoost.title' | translate }}
          </h1>
          <p class="rs-subtit rs-txt-c2" *ngIf="dataBoosts">
            {{ 'mobile.databoost.subtitle' | translate
            }}<mprd-access-number-formatter
              [accessNumber]="mobileProduct?.accessNumber"
              [plc]="mobileProduct?.plc"
            ></mprd-access-number-formatter>
          </p>
          <div class="panel rs-panel-big clearfix">
            <h2 class="rs-tit3">
              {{ 'mobile.databoost.select.option' | translate }}
            </h2>
            <p>
              {{ 'mobile.databoost.select.option.description' | translate }}
            </p>
            <px-alert
              [alerts]="[
                {
                  type: 'error',
                  title: 'mobile.options.error.title' | translate,
                  description: 'mobile.options.error.message' | translate,
                  isClosable: false,
                  taggingErrorType: 'backend'
                }
              ]"
              *ngIf="!dataBoosts && hasError"
            ></px-alert>
            <div class="rs-ctable" *ngIf="dataBoosts">
              <div class="row" role="list">
                <div
                  class="small-12 medium-6 columns"
                  *ngFor="let dataBoost of dataBoosts; let i = index"
                >
                  <div
                    class="rs-ctable-panel jsrs-resizerContainer"
                    *ngIf="dataBoost"
                    data-tms-event="card-click-impression"
                    data-tms-card-zone="data full speed"
                    attr.data-tms-card-name="{{ dataBoost.name }}"
                    attr.data-tms-product="{{ buildTaggingProduct(mobileProduct, dataBoost) }}"
                  >
                    <div class="rs-ctable-panel-info-zone">
                      <div class="rs-ctable-panel-header jsrs-resizerPart">
                        <h3 class="rs-ctable-panel-title">
                          {{ dataBoost.name }}
                        </h3>
                      </div>
                      <div class="jsrs-resizerPart">
                        <p class="rs-txt-s3">
                          {{ dataBoost.description }}
                        </p>
                      </div>
                      <div class="rs-ctable-feature-box">
                        <button
                          class="rs-ctable-feature-box-title"
                          [attr.aria-expanded]="isExpanded"
                          (click)="toggleExpanded()"
                        >
                          {{ 'mobile.databoost.boost.panel.title' | translate
                          }}{{ 'mobile.databoost.boost.panel.volume.' + i | translate
                          }}<i class="rs-ctable-feature-box-title-arrow"></i>
                        </button>
                        <div class="rs-ctable-feature-box-content">
                          <ul class="rs-ctable-feature-list">
                            <li>
                              <i class="rs-ctable-feature-list-icon icon-Digital-media icon-lh"></i
                              >{{ 'mobile.databoost.boost.panel.netflix.youtube.' + i | translate
                              }}{{ 'mobile.databoost.boost.panel.netflix.youtube' | translate }}
                            </li>
                            <li>
                              <i class="rs-ctable-feature-list-icon icon-Music icon-lh"></i
                              >{{ 'mobile.databoost.boost.panel.spotify.apple.' + i | translate
                              }}{{ 'mobile.databoost.boost.panel.spotify.apple' | translate }}
                            </li>
                            <li>
                              <i class="rs-ctable-feature-list-icon icon-Location icon-lh"></i
                              >{{ 'mobile.databoost.boost.panel.maps.waze.' + i | translate
                              }}{{ 'mobile.databoost.boost.panel.maps.waze' | translate }}
                            </li>
                            <li>
                              <i class="rs-ctable-feature-list-icon icon-Photo icon-lh"></i
                              >{{ 'mobile.databoost.boost.panel.instagram.' + i | translate
                              }}{{ 'mobile.databoost.boost.panel.instagram' | translate }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="rs-mh-s1"></div>
                    </div>
                    <div class="rs-ctable-panel-order-zone">
                      <div class="jsrs-resizerPart rs-ctable-price">
                        <p>
                          <px-currency-amount
                            [amount]="dataBoost.price.priceVat.toString()"
                            [amountClass]="'rs-price-sm'"
                          ></px-currency-amount>
                          {{ 'mobile.databoost.boost.price.info' | translate }}
                        </p>
                      </div>
                      <div class="jsrs-resizerPart">
                        <mprd-order-button
                          [(option)]="dataBoosts[i]"
                          [(orderDisabled)]="orderButtonsDisabled"
                          [selectedProduct]="mobileProduct"
                          (resultEmit)="onResult($event)"
                          [isDataBoost]="true"
                        ></mprd-order-button>
                      </div>
                      <div class="rs-ctable-jo">
                        <a
                          href="javascript:void(0)"
                          (click)="redirectToOptionsSection()"
                          class="rs-btn rs-btn-third"
                          attr.data-tms-button-name="{{
                            'mobile.databoost.boost.more.data.link' | translate
                          }}"
                          >{{ 'mobile.databoost.boost.more.data.link' | translate }}
                          <i class="rs-icon-btn-third rs-margin-left1"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
                <px-alert [alertKey]="'dataBoostAlert'"></px-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
